import { CHALLENGE_OBJECT_RESPONSE } from './data/challenge-response-object.data';
import { IAuthenticationRequest } from './../../core/3DS/models/authentication-request/authentication-request.model';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { ThreeDsAuthenticationService } from 'src/app/core/3DS/services/three-ds-authentication.service';
import { environment } from 'src/environments/environment';
import { COMMERCIAL_NETWORKS } from '../../core/constants/CommercialNetwork';
import { COOPENAE, LAFISE, PAYMENTBAKERY, PAYMENTEZ, REDEBAN, NIUBIZ, MOVII } from '../../core/constants/credit-cards-processor.constants';
import { AMEX, CODENSA, CODE_RESPONSE, DINERS_CLUB, MASTERCARD, UNION_PAY, VISA } from '../../core/constants/credit-cards.constants';
import { ALERT_ERRORS, CREDIT_CARD_VALIDATIONS } from '../../core/constants/Errors';
import { DOC_TYPES, DOC_TYPES_CR, DOC_TYPES_EXTERNAL, DOC_TYPES_LAFISE, DOC_TYPES_NIUBIZ, DOC_TYPES_REDEBAN } from '../../core/constants/FormLists';
import { LEGAL_FILES } from '../../core/constants/URLs';
import { Payment, Transaction } from '../../models';
import { CreditTransaction } from '../../models/credit-transaction';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { CountryService } from '../../services/country.service';
import { PayService } from '../../services/pay.service';
import { PaymentMethodsService } from '../../services/payment-methods.service';
import { TokenServiceService } from '../../services/token-service.service';
import { CreditCardValidator } from '../../tools/credit-card.validator';
import { BuyerInformationComponent } from '../buyer-information/buyer-information.component';
import { ThreeDsService } from './../../core/3DS/services/three-ds.service';
import { ICountry } from './../../models/countries';
import { IResponseObject } from './../../models/response-object.model';
import { ADDRESS_COMPLETION, ADDRESS_SUFIX } from './data/address-sufix.data';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICountryRequestBody } from 'src/app/models/countriesRequestBody';
import { Observable, timer } from 'rxjs';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { DATE_FORMATS, DateTool, TIMES } from '../../tools/date';
import { CONSTANTS } from '../../constants/users.constants';
import {
    THREEDS_IFRAME_PARAMETERS,
    HTTP_STATUS_RESPONSE_CODES,
    VALIDATIONS_CONFIG_LIST,
    AUTOCOMPLETE_METHOD_PAY_TYPES,
    API_V4_ERROR_RESPONSE_NETWORK_CODES,
    FLAGS_NAME,
    GENERAL_CONSTANTS,
    ALERT_ICON_CONSTANTS,
    PAYVALIDA_SDK_CONSTANTS,
} from 'src/app/core/constants/General-constants';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PatchValAdditionalInfoService } from '../../services/patch-val-additional-info.service';
import { KountService } from 'src/app/services/kount.service';

export interface AddressInfo {
    line1: string;
    line2: string;
    postalCode: string;
}

@Component({
    selector: 'app-credit-card',
    templateUrl: './credit-card.component.html',
    styleUrls: ['./credit-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: Window, useValue: window }],
})
// TODO: TECHNICAL DEBT 28125 https://dev.azure.com/payvalida/payValida/_workitems/edit/28125
export class CreditCardComponent implements OnInit {
    @Input() info: Payment;
    @Output() TC = new EventEmitter();
    @ViewChild(BuyerInformationComponent)
    buyerInformationComponent: BuyerInformationComponent;
    transaction: Transaction;
    creditTransaction: CreditTransaction;
    coutesArray: any;
    iframeDataResponse: any;
    loading = true;
    token: string;
    template: string;
    CVV = 3;
    cuota: boolean;
    orderID: string;
    form: FormGroup;
    threeDsUsed: boolean = false;
    cvvIsFocus: boolean;
    listOfYears: string[];
    listOfMonths: string[];
    listOfDocuments = [];
    errorsMessages = CREDIT_CARD_VALIDATIONS;
    personalDataURL = LEGAL_FILES.PERSONAL_DATA;
    isMasterCard = false;
    countries: ICountry[] = [];
    states: any[] = [];
    cities: any[] = [];
    addressSufix: string[] = ADDRESS_SUFIX;
    addressCompletion: string[] = ADDRESS_COMPLETION;
    requireChallenge?: boolean = false;
    challengeUrl?: string = '';
    challengeCodeResponse?: string;
    challengeObjectResponse;
    openedModel: boolean = false;
    selectedCountry: string;
    selectedState: string;
    disabledState: boolean = true;
    disabledCity: boolean = true;
    activeDirectionForm: boolean = false;
    activeNetcetera: boolean = false;
    subscription: any;
    responseTest: string;
    transactionPMResponseTemp: any;
    formPrivacyValid: boolean = false;
    objectControlData = [
        {
            formControl: 'name',
            readOnly: false,
        },
        {
            formControl: 'lastname',
            readOnly: false,
        },
        {
            formControl: 'typeDI',
            readOnly: false,
        },
        {
            formControl: 'di',
            readOnly: false,
        },
        {
            formControl: 'cellPhone',
            readOnly: false,
        },
        {
            formControl: 'email',
            readOnly: false,
        },
        {
            formControl: 'billAddrLine1',
            readOnly: false,
        },
        {
            formControl: 'billAddrLine2',
            readOnly: false,
        },
        {
            formControl: 'billAddrPostCode',
            readOnly: false,
        },
    ];
    buyerInfoControl = [
        {
            formControl: 'cellPhone',
            readOnly: false,
        },
        {
            formControl: 'email',
            readOnly: false,
        },
    ];
    addressInfo: AddressInfo;
    isEditableInfo = false;
    threeDSCompInd: string = '';
    lafiseIntegrationff: boolean = false;
    threeDsNewFlowFf: boolean = false;
    threeDsUrl: string;
    threeDsMethod: string;
    threeDSErrorMsg: string = '';
    niubizIntegrationFF: boolean = false;
    fixAutocompleteTokenPersonalInfoFF: boolean = false;
    moviiIntegrationFF: boolean = false;
    threeDsValidatorFixFF: boolean = false;
    validatorErrorFixFF: boolean = false;
    payvalidaSdk: any = this.window[PAYVALIDA_SDK_CONSTANTS.PAYVALIDA_SDK_WINDOW_OBJECT];
    enableExtraCardholderData: boolean = false;
    kountSessionId: string;
    shouldValidateKount: boolean = false;
    transStatusAToKount: boolean = false;

    constructor(
        private readonly authService: AuthService,
        private readonly payService: PayService,
        private readonly alertService: AlertService,
        private readonly router: Router,
        private readonly paymentMethodsService: PaymentMethodsService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly formBuilder: FormBuilder,
        private countryService: CountryService,
        private threeDsService: ThreeDsService,
        private window: Window,
        private threeDsAuthenticationService: ThreeDsAuthenticationService,
        private dialog: MatDialog,
        private tokenService: TokenServiceService,
        private featureFlagService: PayvalidaFeatureFlagService,
        private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
        public kountService: KountService
    ) {
        this.form = this.formBuilder.group({
            ip: [''],
            typeDI: ['', Validators.required],
            di: ['', Validators.compose([Validators.required, Validators.maxLength(25), Validators.minLength(6), Validators.pattern('^[0-9]*$')])],
            franchise: ['', Validators.required],
            name: ['', Validators.compose([Validators.required, Validators.maxLength(45), Validators.pattern('^[A-Za-z0-9ñÑ\\s-_.áÁéÉíÍóÓúÚ]*$')])],
            lastname: ['', Validators.compose([Validators.required, Validators.maxLength(45), Validators.pattern('^[A-Za-z0-9ñÑ\\s-_.áÁéÉíÍóÓúÚ]*$')])],
            cardNumber: [''],
            expirationMonth: ['', Validators.required],
            expirationYear: ['', Validators.required],
            cvv: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]*$')])],
            cuotes: ['', Validators.min(1)],
            token: ['', Validators.required],
        });

        const docTypesObjectKeys = Object.keys(DOC_TYPES);

        for (const prop of docTypesObjectKeys) {
            this.listOfDocuments.push(DOC_TYPES[prop]);
        }

        this.listOfYears = this.getListOfYears();

        this.form.get('expirationMonth').disable();
        this.form.controls.expirationYear.valueChanges.subscribe((value) => {
            this.listOfMonths = this.getListOfMonths(value);
            this.form.get('expirationMonth').enable();
        });

        this.form.controls.cardNumber.valueChanges.subscribe((cardNumber) => {
            const franchise = CreditCardValidator.kindCard(cardNumber);

            if (franchise === AMEX.id || franchise === DINERS_CLUB.id) {
                this.form.get('cvv').setValidators(Validators.compose([Validators.required, Validators.maxLength(4), Validators.minLength(3), Validators.pattern('^[0-9]*$')]));
                this.CVV = 4;
            } else {
                this.form.get('cvv').setValidators(Validators.compose([Validators.required, Validators.maxLength(3), Validators.minLength(3), Validators.pattern('^[0-9]*$')]));
                this.CVV = 3;
            }
        });
    }

    /**
     *
     * @description {onActivate} Function to activate the component
     */
    async initKount() {
        this.shouldValidateKount = await this.kountService.shouldValidateKount({ franchise: this.getCreditCardCode(this.info.franchise) });

        if (this.shouldValidateKount) {
            this.activeDirectionForm = true;

            this.setControlFields();
        }

        return;
    }

    /**
     *
     * @description {onActivate} Function to activate the component
     */
    setControlFields(): void {
        this.getCountries();
        this.form.addControl('billAddrCity', new FormControl('', Validators.required));
        this.form.addControl('billAddrCountry', new FormControl('', Validators.required));
        this.form.addControl('billAddrState', new FormControl('', Validators.required));
        this.form.addControl('billAddrLine1', new FormControl('', Validators.compose([Validators.required, Validators.maxLength(50)])));
        this.form.addControl('billAddrLine2', new FormControl('', Validators.compose([Validators.maxLength(50)])));
        this.form.addControl('billAddrLine3', new FormControl('', Validators.compose([Validators.maxLength(80)])));
        this.form.addControl('billAddrPostCode', new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(16), Validators.minLength(3)])));

        this.isMasterCard = true;

        this.patchValAddressInfo();
    }
    /**
     *
     * @description {patchValAddressInfo} Function to set the direction values of the order
     */
    patchValAddressInfo() {
        let isEditableInfo = this.isEditableInfo ? false : true;

        if (this.addressInfo) {
            if (this.addressInfo.line1) {
                this.form.get('billAddrLine1').setValue(this.addressInfo.line1);
                this.objectControlData.find((m) => m.formControl === 'billAddrLine1').readOnly = isEditableInfo;
            }

            if (this.addressInfo.line2) {
                this.form.get('billAddrLine2').setValue(this.addressInfo.line2);
                this.objectControlData.find((m) => m.formControl === 'billAddrLine2').readOnly = isEditableInfo;
            }

            if (this.addressInfo.postalCode) {
                this.form.get('billAddrPostCode').setValue(this.addressInfo.postalCode);
                this.objectControlData.find((m) => m.formControl === 'billAddrPostCode').readOnly = isEditableInfo;
            }
        }
    }

    getListOfYears(): string[] {
        const years: string[] = [];
        const dateStart = moment();
        const dateEnd = moment().add(10, 'y');

        while (dateEnd.diff(dateStart, 'years') >= 0) {
            years.push(dateStart.format('YYYY'));
            dateStart.add(1, 'year');
        }

        return years;
    }

    getListOfMonths(startDate: string): string[] {
        const months = [];
        startDate = `20${startDate}`;

        if (startDate !== '' && moment().format('YYYY') === startDate) {
            const dateStart = moment();
            const numberOfAfterMonths = 12 - parseInt(dateStart.format('M'), 10);
            const dateEnd = moment().add(numberOfAfterMonths, 'month');

            while (dateEnd.diff(dateStart, 'months') >= 0) {
                months.push(dateStart.format('MM'));
                dateStart.add(1, 'month');
            }
        } else if (startDate !== '') {
            const dateStart = moment(`${startDate}-01-01`, 'YYYY-MM-DD');
            const dateEnd = moment(`${startDate}-01-01`, 'YYYY-MM-DD').add(11, 'month');

            while (dateEnd.diff(dateStart, 'months') >= 0) {
                months.push(dateStart.format('MM'));
                dateStart.add(1, 'month');
            }
        }

        return months;
    }

    async ngOnInit() {
        this.onActivate();

        this.template = this.info.template;
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.LAFISE_FF_PARAMETER, FLAGS_NAME.LAFISE_INTEGRATION).subscribe((response: boolean) => {
            this.lafiseIntegrationff = response;
        });

        this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.THREEDS_NEW_FLOW).subscribe((response: boolean) => {
            this.threeDsNewFlowFf = response;
        });

        let flagParam = this.transaction.MERCHANT_ID === GENERAL_CONSTANTS.TEST_MERCHANTS.KUANTO ? this.transaction.MERCHANT_ID : `${this.transaction.ORDER_CODE}`;

        this.featureFlagService.getFeatureFlagValue(flagParam, FLAGS_NAME.ENABLE_EXTRA_CARDHOLDER_DATA).subscribe((response: boolean) => {
            this.enableExtraCardholderData = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.NIUBIZ_INTEGRATION, FLAGS_NAME.NIUBIZ_INTEGRATION).subscribe((response: boolean) => {
            this.niubizIntegrationFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.FIX_AUTOCOMPLETE_TOKEN, FLAGS_NAME.FIX_AUTOCOMPLETE_TOKEN).subscribe((response: boolean) => {
            this.fixAutocompleteTokenPersonalInfoFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.MOVII_INTEGRATION, FLAGS_NAME.MOVII_INTEGRATION).subscribe((response: boolean) => {
            this.moviiIntegrationFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.FIX_3DS_VALIDATOR_METHOD, FLAGS_NAME.FIX_3DS_VALIDATOR_METHOD).subscribe((response: boolean) => {
            this.threeDsValidatorFixFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.VALIDATOR_ERROR_3DS_FIX, FLAGS_NAME.VALIDATOR_ERROR_3DS_FIX).subscribe((response: boolean) => {
            this.validatorErrorFixFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.TRANS_STATUS_A_TO_KOUNT).subscribe((response: boolean) => {
            this.transStatusAToKount = response;
        });
        
        this.form.get('cardNumber').setValidators([Validators.required, CreditCardValidator.isValidCard(this.info.franchise), Validators.pattern('^[0-9]*$')]);
        this.form.get('cardNumber').updateValueAndValidity();

        this.creditTransaction = new CreditTransaction();
        this.creditTransaction.token = this.token = this.tokenServiceService.getToken();
        this.creditTransaction.di = this.transaction.USER_DI ? this.transaction.USER_DI : '';
        this.creditTransaction.name = this.transaction.USER_NAME ? this.transaction.USER_NAME : '';
        this.creditTransaction.typeDI = this.transaction.USER_TYPE_DI ? this.transaction.USER_TYPE_DI : '';
        this.coutesArray = this.coute();

        switch (this.info.template) {
            case PAYMENTBAKERY.id:
                this.cuota = false;

                this.form.get('cuotes').clearValidators();

                this.creditTransaction.cuotes = 1;

                break;
            case PAYMENTEZ.id:
                this.listOfDocuments = [];

                const docTypesObjectKeys = Object.keys(DOC_TYPES_EXTERNAL);

                for (const prop of docTypesObjectKeys) {
                    this.listOfDocuments.push(DOC_TYPES_EXTERNAL[prop]);
                }

                this.cuota = false;
                this.creditTransaction.cuotes = 1;

                break;
            case COOPENAE.id:
                this.listOfDocuments = [];

                const docTypesKeys = Object.keys(DOC_TYPES_CR);

                for (const prop of docTypesKeys) {
                    this.listOfDocuments.push(DOC_TYPES_CR[prop]);
                }

                this.cuota = false;
                this.creditTransaction.cuotes = 1;

                break;
            case REDEBAN.id:
                this.listOfDocuments = [];

                const docTypesKeysRbm = Object.keys(DOC_TYPES_REDEBAN);

                for (const prop of docTypesKeysRbm) {
                    this.listOfDocuments.push(DOC_TYPES_REDEBAN[prop]);
                }

                this.cuota = true;

                break;
            case LAFISE.id:
                this.listOfDocuments = [];

                const docTypesKeyslafise = Object.keys(DOC_TYPES_LAFISE);

                for (const prop of docTypesKeyslafise) {
                    this.listOfDocuments.push(DOC_TYPES_LAFISE[prop]);
                }

                this.cuota = false;
                this.creditTransaction.cuotes = 1;

                break;
            case NIUBIZ.id:
                this.listOfDocuments = Object.values(DOC_TYPES_NIUBIZ);
                this.cuota = false;
                this.creditTransaction.cuotes = 1;

                break;
            case MOVII.id:
                this.listOfDocuments = Object.values(DOC_TYPES_REDEBAN);
                this.cuota = false;
                this.creditTransaction.cuotes = 1;

                break;
            default:
                this.cuota = true;
        }
        this.form.patchValue(this.creditTransaction);

        try {
            const order = await this.paymentMethodsService.Order();
            this.orderID = order.OrderID;
            this.loading = false;
        } catch (_) {
            this.loading = false;

            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
        }

        this.form.controls.cardNumber.valueChanges.subscribe((value) => {
            const franchise = CreditCardValidator.kindCard(value);
            this.form.controls.franchise.patchValue(this.getCreditCardCode(franchise));
        });

        this.disabledItems();
    }

    changeMethod() {
        this.TC.emit();
    }

    private coute() {
        const coutes = [];
        for (let index = 1; index < 37; index++) {
            coutes[index - 1] = index;
        }
        return coutes;
    }

    /**
     *
     * @description {disabledItems} Function to disabled items to checkout form
     */
    disabledItems() {
        try {
            let additionalInfo = this.tokenService.exitsAdditionalInformation(this.transaction);

            if (additionalInfo) {
                this.isEditableInfo = this.tokenService.isEditableInfo(additionalInfo);

                if (this.fixAutocompleteTokenPersonalInfoFF) {
                    const result = this.patchValAdditionalInfoService.patchValAdditionalInfo(
                        this.isEditableInfo,
                        additionalInfo,
                        this.form,
                        AUTOCOMPLETE_METHOD_PAY_TYPES.TC,
                        this.objectControlData,
                        this.buyerInformationComponent,
                        this.buyerInfoControl
                    );

                    const { addressInfo, buyerInfoControl } = result;
                    this.addressInfo = addressInfo;
                    this.buyerInfoControl = buyerInfoControl;
                    return;
                }

                this.patchValAdditionalInfo(this.isEditableInfo, additionalInfo);
                return;
            }
        } catch (error) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }

    /**
     * @description {patchValueFormsFromToken} Function to map the values of the TC form with the token information
     */
    patchValueFormsFromToken() {
        if (this.transaction.USER_DI) {
            this.form.get('di').disable();
        }
        if (this.transaction.USER_TYPE_DI) {
            this.form.get('typeDI').disable();
        }
    }

    /**
     * @description {patchValAdditionalInfo} Function to map the values of the TC form with the additional information of the token
     */
    patchValAdditionalInfo(isEditableInfo: boolean, additionalInformation: any) {
        isEditableInfo = isEditableInfo ? false : true;
        const { client } = additionalInformation;
        const { personal_information } = client;
        const { address } = client;
        const { contact_information } = personal_information;

        this.validContactIndformation(isEditableInfo, contact_information);
        this.addressInfo = address ? address : '';

        if (!personal_information) return;

        if (personal_information.firstname) {
            this.form.get('name').setValue(personal_information.firstname);
            this.objectControlData.find((m) => m.formControl === 'name').readOnly = isEditableInfo;
        }

        if (personal_information.lastname) {
            this.form.get('lastname').setValue(personal_information.lastname);
            this.objectControlData.find((m) => m.formControl === 'lastname').readOnly = isEditableInfo;
        }

        if (personal_information.document.type) {
            this.form.get('typeDI').setValue(personal_information.document.type);
            this.objectControlData.find((m) => m.formControl === 'typeDI').readOnly = isEditableInfo;
        }

        if (personal_information.document.id) {
            this.form.get('di').setValue(personal_information.document.id);
            this.objectControlData.find((m) => m.formControl === 'di').readOnly = isEditableInfo;
        }
    }

    /**
     * @description {validContactIndformation} Function to validate the contact information of the order
     */
    validContactIndformation(isEditableInfo: boolean, contactInformation: any) {
        this.buyerInfoControl = this.objectControlData
            .filter((item) => item.formControl === 'cellPhone' || item.formControl === 'email')
            .map((item) => ({ formControl: item.formControl, readOnly: item.readOnly }));

        if (!contactInformation) return;

        if (contactInformation.phone) {
            this.buyerInformationComponent.form.controls.cellPhone.setValue(contactInformation.phone);
            this.buyerInfoControl.find((m) => m.formControl === 'cellPhone').readOnly = isEditableInfo;
        }

        if (contactInformation.email) {
            this.buyerInformationComponent.form.controls.email.setValue(contactInformation.email);
            this.buyerInfoControl.find((m) => m.formControl === 'email').readOnly = isEditableInfo;
        }
    }

    /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
    isControlReadOnly(controlName: string): boolean {
        const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);
        return readOnlyControl ? readOnlyControl.readOnly : false;
    }

    getCreditCardCode(franchise: string) {
        switch (franchise) {
            case VISA.id:
                return VISA.code;
            case MASTERCARD.id:
                return MASTERCARD.code;
            case AMEX.id:
                return AMEX.code;
            case DINERS_CLUB.id:
                return DINERS_CLUB.code;
            case UNION_PAY.id:
                return UNION_PAY.code;
            default:
                return CODENSA.code;
        }
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
    };

    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.form.valid && this.formPrivacyValid && this.buyerInformationComponent.form.valid;
    };

    /**
     * @description {validData} Function to validate the payment processing data or validate 3DS
     */
    async validData() {
        this.loading = true;

        this.activeDirectionForm ?
            this.form.patchValue({
                billAddrLine3: this.form.get('billAddrCity').value.replace(/['"]+/g, ''),
                billAddrCity: this.form.get('billAddrCity').value.replace(/['"]+/g, ''),
                billAddrState: this.form.get('billAddrState').value.replace(/['"]+/g, '')
            })
            : this.removeFormControls();

        this.creditTransaction = this.form.value;

        if (this.completedForms()) {
            this.creditTransaction.cardNumber = this.creditTransaction.cardNumber.replace(/\D/g, '');

            this.buyerInformationComponent.saveBuyerInformation();

            // UNDONE: Remove conditional when trans status A to Kount is enabled
            if(!this.transStatusAToKount) {
                if (this.shouldValidateKount) this.kountSessionId = (await this.kountService.doCollect()).SessionID;

                if (this.activeNetcetera) {
                    try {
                        let data = { ...this.form.getRawValue(), ...this.buyerInformationComponent.form.getRawValue() };

                        let iframeResult = await this.payvalidaSdk.startThreedsValidator(data, this.enableExtraCardholderData);

                        let iframeResultValid = typeof iframeResult === 'boolean' ? iframeResult : iframeResult.isApproved;

                        if (!iframeResultValid) {
                            this.loading = false;

                            const errMsg = this.payvalidaSdk.error ? this.payvalidaSdk.error : ALERT_ERRORS.UNEXPECTED_ERROR;

                            return this.alertService.showAlert(errMsg, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                        }

                        this.loading = true;

                        return await this.processPayment();
                        
                    } catch (_) {
                        this.challengeObjectResponse = CHALLENGE_OBJECT_RESPONSE[this.challengeCodeResponse];

                        if (this.challengeObjectResponse) {
                            this.loading = false;

                            this.alertService.showAlertThreeDs(this.challengeObjectResponse.title, this.challengeObjectResponse.body).then(() => {
                                this.form.reset();
                                this.buyerInformationComponent.form.reset();
                            });
                        }

                        return;
                    }
                }
            }

            if (this.activeNetcetera) {
                try {
                    let data = { ...this.form.getRawValue(), ...this.buyerInformationComponent.form.getRawValue() }

                    let threeDsResponse = await this.payvalidaSdk.startThreedsValidator(data, this.enableExtraCardholderData)

                    if (!threeDsResponse.isApproved) {
                        this.loading = false;

                        const errMsg = this.payvalidaSdk.error ? this.payvalidaSdk.error : ALERT_ERRORS.UNEXPECTED_ERROR;

                        return this.alertService.showAlert(errMsg, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                    }

                    if (this.shouldValidateKount || threeDsResponse.isKountValidationRequired) this.kountSessionId = (await this.kountService.doCollect()).SessionID;

                    this.loading = true;

                    return await this.processPayment();
                    
                } catch (_) {
                    this.challengeObjectResponse = CHALLENGE_OBJECT_RESPONSE[this.challengeCodeResponse];

                    if (this.challengeObjectResponse) {
                        this.loading = false;

                        this.alertService.showAlertThreeDs(this.challengeObjectResponse.title, this.challengeObjectResponse.body).then(() => {
                            this.form.reset();
                            this.buyerInformationComponent.form.reset();
                        });
                    }
                    return;
                }
            }

            if (this.shouldValidateKount) this.kountSessionId = (await this.kountService.doCollect()).SessionID;

            return await this.processPayment();

        }
        
        this.loading = false;
        this.alertService.showAlert(ALERT_ERRORS.DATA_IMCOMPLETED, 'warning');
    }

    /** Función que obtiene todos los paises registrados */
    getCountries(): void {
        try {
            const token = this.tokenService.getToken();

            let requestBody: ICountryRequestBody = {
                token: token,
                country: '',
                state: '',
            };

            this.countryService.getAllCountries(requestBody).subscribe((res: IResponseObject<ICountry[]>) => {
                if (res.DATA) {
                    this.countries = res.DATA.sort();

                    this.form.get('billAddrCountry').setValue('Colombia');
                    this.selectedCountry = 'Colombia';
                    this.selectCountry();
                }
            });
        } catch (error) {
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
        }
    }

    /**
     * @description {threeDsValidator} function to validate the flow of three DS
     * @returns response promise to threeDs
     */
    async threeDsValidator(): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            let validatorRequest: IAuthenticationRequest;

            validatorRequest = this.threeDsAuthenticationService.buildThreeDsValidatorRequest(this.form, this.buyerInformationComponent, this.info.franchise);
            if (this.threeDsValidatorFixFF) {
                return await this.threeDsValidatorServiceMethod(validatorRequest)
                    .then((_) => {
                        resolve(true);
                    })
                    .catch((err) => {
                        reject(`Res threeDsValidatorServiceMethod catch: ${err}`);
                    });
            }

            await this.threeDsService
                .threeDsValidatorService(validatorRequest)
                .then((res) => {
                    if (res?.CODE !== CONSTANTS.CODE_OK && !res?.DATA?.isChallengeRequired && !res?.DATA?.approvedTransaction) {
                        this.alertService.showAlert(res.DESC, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                        this.loading = false;
                        this.threeDSErrorMsg = res.DESC;

                        reject(false);
                    }

                    const threeDsAscUrl: string = res?.DATA?.challengeInfo?.acsURL;
                    const threeDsChallengeReq: string = res?.DATA?.challengeInfo?.base64EncodedChallengeRequest;
                    const threeDsMethodUrl: string = res?.DATA?.challengeInfo?.threeDSMethodURL;
                    const threeDsMethodData: string = res?.DATA?.challengeInfo?.methodDataForm?.threeDSMethodData;

                    if ((!threeDsAscUrl || !threeDsChallengeReq || !threeDsMethodUrl || !threeDsMethodData) && res?.DATA?.isChallengeRequired) {
                        this.alertService.showAlert(res.DESC, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                        this.loading = false;
                        this.threeDSErrorMsg = res.DESC;

                        reject(false);
                    }

                    sessionStorage.setItem(GENERAL_CONSTANTS.TRANSACTION_ID, res?.DATA?.threeDSServerTransID);
                    if (res?.DATA?.isChallengeRequired && !res?.DATA?.approvedTransaction) {
                        let iframe = document.getElementById(THREEDS_IFRAME_PARAMETERS.FRAME_CONTAINER);

                        this.window[THREEDS_IFRAME_PARAMETERS.WEB_SDK].createIframeAndInit3DSMethod(threeDsMethodUrl, threeDsMethodData, THREEDS_IFRAME_PARAMETERS.IFRAME_CONTAINER, iframe, () => { });

                        const modal: MatDialogRef<IframeDialog> = this.dialog.open(IframeDialog, {
                            width: THREEDS_IFRAME_PARAMETERS.IFRAME_DIALOG_WIDTH,
                            height: THREEDS_IFRAME_PARAMETERS.IFRAME_DIALOG_HEIGHT,
                            data: {
                                window: this.window,
                                threeDsAscUrl: threeDsAscUrl,
                                threeDsChallengeReq: threeDsChallengeReq,
                            },
                        });

                        this.openedModel = true;
                        let bodyRequest = { token: this.tokenService.getToken() };
                        this.subscription = timer(environment.timer3dsInit, environment.timer3dsFinal).subscribe(async (_) => {
                            this.loading = true;
                            try {
                                const rpta = (await this.payService.iframeValidation(bodyRequest).toPromise()).CODE;

                                if (rpta === CONSTANTS.CODE_OK) {
                                    this.cancelTimer();
                                    modal.close();

                                    resolve(true);
                                }

                                if (rpta !== CONSTANTS.CODE_OK && rpta !== CONSTANTS.CODE_ERROR) {
                                    this.cancelTimer();
                                    modal.close();
                                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                                    reject(false);
                                }
                            } catch (_) {
                                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                                modal.close();
                                this.cancelTimer();

                                reject(false);
                            }
                        });
                    }

                    res?.DATA?.approvedTransaction ? resolve(true) : reject(false);
                })
                .catch((error) => {
                    const errMsg = !error?.error?.DESC ? ALERT_ERRORS.UNEXPECTED_ERROR : error?.error?.DESC;

                    this.alertService.showAlert(errMsg, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                    this.threeDSErrorMsg = errMsg;
                    this.loading = false;

                    reject(false);
                });
        });
    }

    /**
     * @description {threeDsValidatorServiceMethod} The function returns the result of the various validations performed by the 3DS 'validator' service.
     * @returns response promise of valitor service
     */
    async threeDsValidatorServiceMethod(validatorRequest) {
        //TODO task: 34749 (refactor) https://dev.azure.com/payvalida/payValida/_workitems/edit/34749
        return new Promise(async (resolve, reject) => {
            await this.threeDsService
                .threeDsValidatorService(validatorRequest)
                .then((res) => {
                    if (res.CODE === CONSTANTS.CODE_OK) {
                        if (res?.DATA?.isChallengeRequired && !res?.DATA?.approvedTransaction) {
                            const threeDsAscUrl: string = res?.DATA?.challengeInfo?.acsURL;
                            const threeDsChallengeReq: string = res?.DATA?.challengeInfo?.base64EncodedChallengeRequest;
                            const threeDsMethodUrl: string = res?.DATA?.challengeInfo?.threeDSMethodURL;
                            const threeDsMethodData: string = res?.DATA?.challengeInfo?.methodDataForm?.threeDSMethodData;

                            if ((!threeDsAscUrl || !threeDsChallengeReq || !threeDsMethodUrl || !threeDsMethodData) && res?.DATA?.isChallengeRequired) {
                                this.alertService.showAlert(res.DESC, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                                this.loading = false;
                                this.threeDSErrorMsg = res.DESC;

                                reject(false);
                            }

                            sessionStorage.setItem(GENERAL_CONSTANTS.TRANSACTION_ID, res?.DATA?.threeDSServerTransID);
                            let iframe = document.getElementById(THREEDS_IFRAME_PARAMETERS.FRAME_CONTAINER);

                            this.window[THREEDS_IFRAME_PARAMETERS.WEB_SDK].createIframeAndInit3DSMethod(
                                threeDsMethodUrl,
                                threeDsMethodData,
                                THREEDS_IFRAME_PARAMETERS.IFRAME_CONTAINER,
                                iframe,
                                () => { }
                            );

                            const modal: MatDialogRef<IframeDialog> = this.dialog.open(IframeDialog, {
                                width: THREEDS_IFRAME_PARAMETERS.IFRAME_DIALOG_WIDTH,
                                height: THREEDS_IFRAME_PARAMETERS.IFRAME_DIALOG_HEIGHT,
                                data: {
                                    window: this.window,
                                    threeDsAscUrl: threeDsAscUrl,
                                    threeDsChallengeReq: threeDsChallengeReq,
                                },
                            });

                            this.openedModel = true;
                            let bodyRequest = { token: this.tokenService.getToken() };
                            this.subscription = timer(environment.timer3dsInit, environment.timer3dsFinal).subscribe(async (_) => {
                                this.loading = true;

                                try {
                                    let rpta = (await this.payService.iframeValidation(bodyRequest).toPromise()).CODE;

                                    if (rpta === CONSTANTS.CODE_OK) {
                                        this.cancelTimer();
                                        modal.close();

                                        resolve(true);
                                    }

                                    if (rpta !== CONSTANTS.CODE_OK && rpta !== CONSTANTS.CODE_ERROR) {
                                        this.cancelTimer();
                                        modal.close();

                                        reject(false);

                                        this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                                    }
                                } catch (_) {
                                    this.cancelTimer();
                                    modal.close();
                                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                                }
                            });
                        } else if (res?.DATA?.approvedTransaction && !res?.DATA?.isChallengeRequired) {
                            resolve(true);
                        } else {
                            this.loading = false;

                            this.alertService.showAlert(ALERT_ERRORS.THREEDS_VALIDATION_ERROR, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                        }
                    } else {

                        if (this.validatorErrorFixFF) {
                            const errMsg = !res?.DESC ? ALERT_ERRORS.UNEXPECTED_ERROR : res?.DESC;
                            this.loading = false;

                            return this.alertService.showAlert(errMsg, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
                        }

                        reject(`Error [threeDsService]: ${res.DESC}`);
                    }
                })
                .catch((error) => {
                    const errMsg = !error?.error?.DESC ? ALERT_ERRORS.UNEXPECTED_ERROR : error?.error?.DESC;

                    this.alertService.showAlert(errMsg, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                    this.threeDSErrorMsg = errMsg;
                    this.loading = false;

                    reject(false);
                });
        });
    }

    async openThreeDSIframe(authenticationRequest: IAuthenticationRequest, threeDsurl: string, threeDsMethod: string) {
        return new Promise(async (resolve, reject) => {
            await this.threeDsService
                .authenticationRequest(authenticationRequest)
                .then((res) => {
                    if (res.CODE === CONSTANTS.CODE_OK) {
                        if (res && (res.DATA.transStatus === 'C' || res.DATA.transStatus === 'D')) {
                            sessionStorage.setItem('transactionId', res.DATA.threeDSServerTransID);
                            if (this.threeDsNewFlowFf) {
                                let iframe = document.getElementById('frameContainer');
                                if (!threeDsurl || !threeDsMethod) {
                                    reject(false);
                                }
                                this.window[THREEDS_IFRAME_PARAMETERS.WEB_SDK].createIframeAndInit3DSMethod(threeDsurl, threeDsMethod, THREEDS_IFRAME_PARAMETERS.IFRAME_CONTAINER, iframe, () => { });
                            }
                            const modal = this.dialog.open(IframeDialog, {
                                width: '450px',
                                height: '550px',
                                data: {
                                    window: this.window,
                                    res: res,
                                },
                            });
                            this.openedModel = true;
                            const token = this.tokenService.getToken();
                            let bodyRequest = {
                                token: token,
                            };
                            /** Timer para el llamado de la validación del iframe */
                            this.subscription = timer(environment.timer3dsInit, environment.timer3dsFinal).subscribe(async (n) => {
                                this.loading = true;
                                try {
                                    const rpta = (await this.payService.iframeValidation(bodyRequest).toPromise()).CODE;

                                    if (rpta === CONSTANTS.CODE_OK) {
                                        this.cancelTimer();
                                        modal.close();
                                        resolve(true);
                                    } else if (rpta !== CONSTANTS.CODE_OK && rpta !== '0001') {
                                        this.cancelTimer();
                                        modal.close();
                                        reject(false);
                                        this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
                                    }
                                } catch (error) {
                                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
                                    modal.close();
                                    this.cancelTimer();
                                }
                            });
                        } else if (res.DATA.transStatus === 'Y') {
                            this.threeDsUsed = true;
                            resolve(true);
                        } else {
                            this.challengeCodeResponse = res.DATA.transStatus;
                            if (this.challengeCodeResponse && this.challengeCodeResponse.length > 0) {
                                reject(false);
                            } else {
                                this.alertService.showAlert(ALERT_ERRORS.THREEDS_VALIDATION_ERROR, 'warning');
                                this.loading = false;
                            }
                        }
                    } else {
                        reject(`Error [threeDsService]: ${res.DESC}`);
                    }
                })
                .catch((err) => {
                    reject(`Error [threeDsService]: ${err}`);
                });
        });
    }

    /**
     * Method to process payment
     */
    async processPayment() {
        let diValue = this.form.get('di').value;
        let typeDiValue = this.form.get('typeDI').value;
        this.creditTransaction.di = diValue;
        this.creditTransaction.typeDI = typeDiValue;
        this.transactionPMResponseTemp = '';

        if(this.kountSessionId && this.kountSessionId != '') this.creditTransaction.kountSessionId = this.kountSessionId;

        if (this.activeDirectionForm) {
            this.creditTransaction.billAddrCity = this.creditTransaction.billAddrCity.replace(/['"]+/g, '');
            this.creditTransaction['billAddrState'] = this.creditTransaction['billAddrState'].replace(/['"]+/g, '');
        }

        this.authService.setUserInfo(this.creditTransaction);

        // TODO: TECHNICAL DEBT 34678 https://dev.azure.com/payvalida/payValida/_workitems/edit/34678
        if (this.info.code === COMMERCIAL_NETWORKS.REDEBAN) {
            try {
                // Se obtienen eston datos solo cuando el formulario de facturación sea activado

                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;

                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;

                const transactionRBResponse: any = await this.payService.tctransactionRB(this.creditTransaction);
                if (transactionRBResponse.result === '401') {
                    this.loading = false;

                    this.alertService.showAlert(transactionRBResponse.error, 'warning');
                } else {
                    this.authService.setTC(transactionRBResponse);
                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else if (this.info.code === COMMERCIAL_NETWORKS.CREDIBANCO || this.info.code === COMMERCIAL_NETWORKS.CREDIBANCO_USD) {
            try {
                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;
                const transactionCBResponse: any = await this.payService.processsPaymentCB(this.creditTransaction);

                if (transactionCBResponse.result === '401') {
                    this.loading = false;

                    this.alertService.showAlert(transactionCBResponse.error, 'warning');
                } else {
                    this.authService.setTC(transactionCBResponse);
                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else if (this.info.code === COMMERCIAL_NETWORKS.PAYMENTEZ_ECU || this.info.code === COMMERCIAL_NETWORKS.PAYMENTEZ_PER) {
            if (this.creditTransaction.franchise === 'diners_club') {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.DINERS_ERROR, 'warning');
            } else {
                try {
                    this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                    this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;

                    const transactionPMResponse: any = await this.payService.processpaymentPM(this.creditTransaction);
                    this.transactionPMResponseTemp = transactionPMResponse;

                    if (transactionPMResponse.result === '401') {
                        this.loading = false;
                        this.alertService.showAlert(transactionPMResponse.error, 'warning');
                    } else if (transactionPMResponse.data.transaction.responseCode === 'PENDIENTE') {
                        /**APERTURA DEL MODAL*/
                        this.callOtpModal().then(async (responseModal) => {
                            if (responseModal) {
                                if (responseModal.CODE === CODE_RESPONSE.TRANSACTION_INCORRECT) {
                                    this.returnRetryPayment();
                                }
                                this.loading = false;
                            } else {
                                this.loading = false;
                            }
                        });
                    } else {
                        this.authService.setTC(transactionPMResponse);
                        await this.router.navigate(['checkout/alertTC']);
                    }
                } catch (_) {
                    this.loading = false;

                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
                }
                this.loading = false;
            }
        } else if (this.info.code === COMMERCIAL_NETWORKS.COOPENAE || this.info.code === COMMERCIAL_NETWORKS.COOPENAE_USD) {
            try {
                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;
                const transactioonCoopenaeResponse: any = await this.payService.processPaymentCoopenae(this.creditTransaction);

                if (transactioonCoopenaeResponse.result === '401') {
                    this.loading = false;

                    this.alertService.showAlert(transactioonCoopenaeResponse.error, 'warning');
                } else {
                    let dateVoucher = transactioonCoopenaeResponse.data.transaction.date;

                    if (dateVoucher.split(' ').length === 2) {
                        let dateAux = new Date(new Date(dateVoucher).getTime() - TIMES.ONE_HOUR);
                        dateVoucher = DateTool.formatDate(dateAux, DATE_FORMATS.YYYY_MM_DD_HH_MM_SS);
                    }

                    transactioonCoopenaeResponse.data.transaction.date = dateVoucher;

                    this.authService.setTC(transactioonCoopenaeResponse);
                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else if ((this.info.code === COMMERCIAL_NETWORKS.LAFISE || this.info.code === COMMERCIAL_NETWORKS.LAFISE_USD) && this.lafiseIntegrationff) {
            try {
                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;
                this.creditTransaction.installments = this.creditTransaction.cuotes;

                delete this.creditTransaction.cuotes;

                const lafiseResponse: any = await this.payService.processPaymentLafise(this.creditTransaction);

                if (lafiseResponse.code === '401') {
                    this.loading = false;

                    this.alertService.showAlert(lafiseResponse.error, 'warning');
                } else {
                    this.authService.setTC(lafiseResponse);

                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else if ((this.info.code === COMMERCIAL_NETWORKS.NIUBIZ || this.info.code === COMMERCIAL_NETWORKS.NIUBIZ_USD) && this.niubizIntegrationFF) {
            try {
                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;
                this.creditTransaction.installments = this.creditTransaction.cuotes;

                delete this.creditTransaction.cuotes;

                const niubizResponse: any = await this.payService.processPaymentNiubiz(this.creditTransaction);

                if (niubizResponse.code === HTTP_STATUS_RESPONSE_CODES.UNAUTHORIZED) {
                    this.loading = false;

                    this.alertService.showAlert(niubizResponse.error, 'warning');
                } else {
                    this.authService.setTC(niubizResponse);

                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else if (this.info.code === COMMERCIAL_NETWORKS.MOVII && this.moviiIntegrationFF) {
            try {
                this.creditTransaction.email = this.buyerInformationComponent.form.controls.email.value;
                this.creditTransaction.phone_number = this.buyerInformationComponent.form.controls.cellPhone.value;
                this.creditTransaction.installments = this.creditTransaction.cuotes;
                this.creditTransaction.withCvv = true;

                delete this.creditTransaction.cuotes;
                this.creditTransaction.kountSessionId = this.kountSessionId;

                const moviiResponse: any = await this.payService.processPaymentMovii(this.creditTransaction);
                if (moviiResponse.code === HTTP_STATUS_RESPONSE_CODES.UNAUTHORIZED) {
                    this.loading = false;
                    return this.alertService.showAlert(moviiResponse.error, 'warning');
                }

                if (this.apiV4ResponseErrorCodes(moviiResponse.CODE)) {
                    let errorMsg = '';

                    switch (moviiResponse.CODE) {
                        case API_V4_ERROR_RESPONSE_NETWORK_CODES.WRONG_REQUEST:
                        case API_V4_ERROR_RESPONSE_NETWORK_CODES.INVALID_REQUEST:
                        case API_V4_ERROR_RESPONSE_NETWORK_CODES.INVALID_PAYMENT:
                            errorMsg = ALERT_ERRORS.REQUEST_ERRORS;
                            break;
                        case API_V4_ERROR_RESPONSE_NETWORK_CODES.VALIDATE_3DS_ERROR:
                            errorMsg = ALERT_ERRORS.THREEDS_VALIDATION_ERROR;
                            break;
                        default:
                            errorMsg = ALERT_ERRORS.UNEXPECTED_ERROR_SUPPORT;
                            break;
                    }

                    this.loading = false;

                    return this.alertService.showAlert(errorMsg, 'warning');
                }

                this.authService.setTC(moviiResponse);

                await this.router.navigate(['checkout/alertTC']);
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        } else {
            try {
                this.creditTransaction.name = this.creditTransaction.name + ' ' + this.form.controls.lastname.value;
                const transactionResponse: any = await this.payService.tctransaction(this.creditTransaction);

                if (transactionResponse.result === '401') {
                    this.loading = false;

                    this.alertService.showAlert(transactionResponse.error, 'warning');
                } else {
                    this.authService.setTC(transactionResponse);

                    await this.router.navigate(['checkout/alertTC']);
                }
            } catch (_) {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            }
        }

        this.loading = false;
    }

    /**
     * @description returns if the response code belongs to those of v4 response codes
     */
    apiV4ResponseErrorCodes(code: string) {
        return Object.values(API_V4_ERROR_RESPONSE_NETWORK_CODES).includes(code);
    }

    onActivate() {
        window.scroll(0, 0);
    }

    /** Función que carga los estados por pais seleccionado */
    selectCountry() {
        this.disabledCity = true;
        this.cities = [];
        this.form.get('billAddrCity').setValue('');

        let selectedCountry = this.selectedCountry;
        try {
            const token = this.tokenService.getToken();
            /** Cargar estados de los paises */
            let requestBody: ICountryRequestBody = {
                token: token,
                country: selectedCountry.replace(/['"]+/g, ''),
                state: '',
            };

            this.countryService.getAllCountries(requestBody).subscribe((res: IResponseObject<any[]>) => {
                if (res.DATA) {
                    this.states = res.DATA.sort();
                }
                if (this.states.length > 0 && this.states) {
                    this.disabledState = false;
                    this.disabledCity = false;
                } else {
                    this.disabledState = true;
                    this.disabledCity = true;
                    this.form.get('billAddrState').setValue('');
                    this.form.get('billAddrCity').setValue('');
                }
            });
        } catch (error) {
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
        }
    }

    /** Función que carga las ciudades por estado seleccionado */
    selectState() {
        this.form.get('billAddrCity').setValue('');
        this.disabledCity = true;
        try {
            const token = this.tokenService.getToken();
            /** Cargar estados de los paises */
            let requestBody: ICountryRequestBody = {
                token: token,
                country: this.selectedCountry.replace(/['"]+/g, ''),
                state: this.selectedState.replace(/['"]+/g, ''),
            };

            this.countryService.getAllCountries(requestBody).subscribe((res: IResponseObject<any[]>) => {
                if (res.DATA) {
                    this.cities = res.DATA.sort();
                }
                if (this.cities.length > 0 && this.cities) {
                    this.disabledCity = false;
                } else {
                    this.disabledCity = true;
                    this.form.get('billAddrCity').setValue('');
                }
                this.disabledCity = this.cities.length > 0 && this.cities ? false : true;
            });
        } catch (error) {
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
        }
    }

    /** Función que construye la data de envio del formulario de tarjeta de crédito */
    buildData(): any {
        let city = this.form.get('billAddrCity').value;
        let country = this.form.get('billAddrCountry').value.toString();
        let state = this.form.get('billAddrState').value;

        let bodyRequest = {
            phone_number: this.buyerInformationComponent.form.controls.cellPhone.value,
            email: this.buyerInformationComponent.form.controls.email.value,
            name: this.form.get('name').value,
            lastname: this.form.get('lastname').value,
            typeDI: this.form.get('typeDI').value,
            di: this.form.get('di').value,
            cardNumber: this.form.get('cardNumber').value,
            expirationYear: this.form.get('expirationYear').value,
            expirationMonth: this.form.get('expirationMonth').value,
            expiration: this.form.get('expirationYear').value + this.form.get('expirationMonth').value,
            cvv: this.form.get('cvv').value,
            cuotes: this.form.get('cuotes').value,
            country: country.replace(/['"]+/g, ''),
            state: state.replace(/['"]+/g, ''),
            city: city.replace(/['"]+/g, ''),
            addrLine1: this.form.get('billAddrLine1').value,
            addrLine2: this.form.get('billAddrLine2').value,
            addrLine3: this.form.get('billAddrLine2').value,
            postCode: this.form.get('billAddrPostCode').value,
            franchise: this.getCreditCardCode(this.info.franchise),
            token: this.tokenService.getToken(),
        };

        return bodyRequest;
    }

    /**
     * @description {activateCallConfigurableList} Function that calls the configurable lists
     */
    activateCallConfigurableList() {
        this.activeNetcetera = false;

        if (this.form.get('cardNumber').valid) {
            this.callConfigurableList(this.form.get('cardNumber').value, 'typeDI');
        }
    }

    /**
     *
     * @description {callConfigurableList} Function that validates the credit card bin and calls the configurable lists
     */
    callConfigurableList(cardNumber: string, inputType: string) {
        let cardBin = cardNumber ? cardNumber.substring(0, 6) : '';

        if (cardBin && this.form.get(inputType).value) {
            this.getConfigurableLists(cardBin, this.form.get(inputType).value);
        }

        this.initKount();
    }

    /**
     *
     * @description {getConfigurableLists} Function that gets the configurable lists for 3DS validation
     */
    getConfigurableLists(cardBin: string, typeDI: string) {
        this.loading = true;

        this.removeFormControls();

        this.activeDirectionForm = false;
        let franchise = this.info.franchise;
        let comercialNetwork = this.info.originCode.toString();
        let configurableList = [];
        let bodyRequest = {
            merchantCode: this.transaction.MERCHANT_CODE.toString(),
            bin: cardBin,
            documentType: typeDI,
        };

        this.payService.getConfigurableLists(bodyRequest).subscribe({
            next: (response) => {
                configurableList = response.DATA;
                let filteredConfigurableList = configurableList.filter(
                    (m) => m.commercial_network === comercialNetwork && (m.validation === VALIDATIONS_CONFIG_LIST.CLEARSALE || m.validation === VALIDATIONS_CONFIG_LIST.NETCETERA)
                );

                if (filteredConfigurableList && filteredConfigurableList.length > 0) {
                    for (let item of filteredConfigurableList) {
                        if (item.franchise == '' || item.franchise == franchise) {
                            this.activeDirectionForm = true;
                            this.loading = false;

                            if (item.validation === '7') {
                                this.activeNetcetera = true;
                            }

                            this.setControlFields();
                        }
                    }
                }

                this.loading = false;
            },
            error: () => {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
            },
        });
    }

    /** Función que cancela el timer */
    cancelTimer() {
        this.subscription.unsubscribe();

        this.loading = false;
    }

    /** Función que abre el modal para validar el código OTP */
    async callOtpModal(): Promise<any> {
        let timerInterval: any;
        let responseModal: IResponseObject<any>;
        let errorOK: string = '';

        let data = await Swal.fire({
            html:
                "<div class='custom-container-otp'>" +
                `<h1>${DINERS_CLUB.modal.title}</h1> ` +
                `<p>${DINERS_CLUB.modal.code}</p>` +
                "<div class='div-code-otp'>" +
                "<input type='password' class='form-control-otp' id='password'></input>" +
                `<svg style="margin-top: 0.2em; padding: 0.3em; role="img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="lock"
                    class="svg-inline--fa fa-lock" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512">
                    <path fill="currentColor"
                      d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z">
                    </path>
                  </svg>` +
                '</div>' +
                "<div class='info-time-otp'>" +
                `<small>${DINERS_CLUB.modal.closeWindowDesc} <strong></strong> ${DINERS_CLUB.modal.closeWindowDescPay}</small>` +
                '</div>' +
                '</div>',
            showConfirmButton: true,
            confirmButtonText: `${DINERS_CLUB.modal.confirmButtonText}`,
            closeButtonHtml: `
            <svg style="padding: 0.3em" role="img" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left"
              class="svg-inline--fa fa-arrow-left" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"><path fill="currentColor"
              d="M447.1 256C447.1 273.7 433.7 288 416 288H109.3l105.4 105.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H416C433.7 224 447.1 238.3 447.1 256z">
              </path>
            </svg>
            <span> ${DINERS_CLUB.modal.cancelPayment}</span> `,
            showCloseButton: true,
            buttonsStyling: false,
            preConfirm: () => {
                return new Promise((resolve, reject) => {
                    if ((document as any).getElementById('password')!.value) {
                        this.validateOtp((document as any).getElementById('password')!.value).subscribe((result) => {
                            if (result === CODE_RESPONSE.TRANSACTION_INCORRECT) {
                                errorOK = CODE_RESPONSE.TRANSACTION_INCORRECT;
                                Swal.showValidationMessage(DINERS_CLUB.modal.errorCharacters);
                            } else {
                                errorOK = CODE_RESPONSE.TRANSACTION_CORRECT;
                                resolve((document as any).getElementById('password')!.value);
                            }
                        });
                    } else {
                        errorOK = CODE_RESPONSE.TRANSACTION_INCORRECT;
                        Swal.showValidationMessage(DINERS_CLUB.modal.infoCode);
                    }
                    Swal.enableButtons();
                });
            },
            timer: 300000,
            customClass: {
                title: 'custom-title-otp',
                closeButton: 'close-button-modal-otp',
                popup: 'popup-custom-otp',
                confirmButton: 'confirm-button-otp',
            },
            didOpen: () => {
                timerInterval = setInterval(() => {
                    const date = new Date(Swal.getTimerLeft()!);
                    Swal.getHtmlContainer()!.querySelector('strong')!.textContent = `${date.getMinutes()} ${DINERS_CLUB.modal.minutesDesc} ${date.getSeconds()} ${DINERS_CLUB.modal.secondsDesc}`;
                }, 100);
            },
            willClose: () => {
                if (!(document as any).getElementById('password')!.value || errorOK === CODE_RESPONSE.TRANSACTION_INCORRECT) {
                    this.returnRetryPayment();
                }
                this.loading = false;
                clearInterval(timerInterval);
            },
        });

        if (data.dismiss) {
            responseModal = {
                CODE: CODE_RESPONSE.TRANSACTION_INCORRECT,
                DATA: '',
            };
        } else if (data.isConfirmed) {
            try {
                const token = this.tokenService.getToken();
                let requestBody: any = {
                    token: token,
                    otp_code: data.value,
                };
                responseModal = await this.verifyOtp(requestBody, responseModal, data);
                if (responseModal.CODE === CODE_RESPONSE.TRANSACTION_CORRECT) {
                    this.authService.setTC(responseModal.DATA);
                    await this.router.navigate(['checkout/alertTC']);
                } else if (responseModal.CODE === CODE_RESPONSE.TRANSACTION_INCORRECT) {
                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'warning');
                }
            } catch (error) {
                responseModal = {
                    CODE: CODE_RESPONSE.TRANSACTION_INCORRECT,
                    DATA: '',
                };
            }
        }
        clearInterval(timerInterval);
        return responseModal;
    }

    /** Función que verifica el código OTP enviado en el modal */
    verifyOtp(requestBody: any, responseModal: any, data: any): Promise<any> {
        this.loading = true;

        return new Promise((resolve, reject) => {
            this.payService.verifyPaymentezTransaction(requestBody).subscribe(
                (response) => {
                    if (response.result !== CODE_RESPONSE.TRANSACTION_INCORRECT) {
                        if (response.data.transaction.responseCode === DINERS_CLUB.modal.pendingMessagge) {
                            this.callOtpModal();
                            Swal.showValidationMessage(DINERS_CLUB.modal.infoCodePending);
                            Swal.enableButtons();
                            responseModal = {
                                CODE: '0003',
                                DATA: '',
                            };
                        } else if (response.data.transaction.responseCode === 'APROBADA' || response.data.transaction.responseCode === 'RECHAZADA') {
                            responseModal = {
                                CODE: CODE_RESPONSE.TRANSACTION_CORRECT,
                                DATA: response,
                            };
                        } else {
                            responseModal = {
                                CODE: CODE_RESPONSE.TRANSACTION_INCORRECT,
                                DATA: data.value,
                            };
                        }
                    } else {
                        responseModal = {
                            CODE: CODE_RESPONSE.TRANSACTION_INCORRECT,
                            DATA: data.value,
                        };
                    }

                    resolve(responseModal);
                },
                (error: any) => reject(error)
            );
        });
    }

    /** Validación de código OTP */
    validateOtp(otp: any): Observable<any> {
        return new Observable((observer) => {
            if (otp.toString().length < 6) {
                observer.next(CODE_RESPONSE.TRANSACTION_INCORRECT);
            } else {
                observer.next(CODE_RESPONSE.TRANSACTION_CORRECT);
            }
        });
    }

    /** Funcion que retorma a la vista de pago incorrecto cuando el tiempo del modal se cumple */
    returnRetryPayment() {
        this.transactionPMResponseTemp.data.transaction.responseCode = 'FALLIDA';

        this.authService.setTC(this.transactionPMResponseTemp);
        this.router.navigate(['checkout/alertTC']);
    }

    /**
     *
     * @description {removeFormControls} Function to remove form direction control
     */
    removeFormControls() {
        this.selectedState = '';
        let groupsList = ['billAddrCountry', 'billAddrState', 'billAddrCity', 'billAddrLine1', 'billAddrLine2', 'billAddrLine3', 'billAddrPostCode'];

        groupsList.forEach((controlName) => {
            this.form.removeControl(controlName);
        });
    }
}

@Component({
    selector: 'ifram-dialog',
    template: ` <div id="frameContainer1"></div>
        <mat-progress-bar mode="buffer" [ngStyle]="{ poistion: 'absolute', top: '500px' }"></mat-progress-bar>`,
    styles: [],
})

export class IframeDialog implements OnInit {
    constructor(public dialogRef: MatDialogRef<IframeDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {

        const frame = document.getElementById('frameContainer1');

        if (!this.data.threeDsAscUrl && !this.data.threeDsChallengeReq) {
            this.data.threeDsAscUrl = this.data.res.DATA.acsURL;
            this.data.threeDsChallengeReq = this.data.res.DATA.base64EncodedChallengeRequest;
        }

        this.data.window[THREEDS_IFRAME_PARAMETERS.WEB_SDK].createIFrameAndInit3DSChallengeRequest(
            this.data.threeDsAscUrl,
            this.data.threeDsChallengeReq,
            THREEDS_IFRAME_PARAMETERS.ZERO_TWO,
            THREEDS_IFRAME_PARAMETERS.REQ_05,
            frame,
            () => { }
        );
    }
}
